import styled from 'styled-components';
import { Tooltip } from 'ui/tooltip';
import { Body2, spacing, colors } from 'ui/theme';
import { useOrganizationMembersQueryContext } from '../../../contexts/OrganizationMembersQueryContext';
import { Project } from '../../../types';
import { MemberRow } from '../types';
import { TableCell, UlNoPadding } from './styled';

const Body2Underline = styled(Body2)`
  display: inline-block;
  text-decoration: underline dashed ${colors.textSecondary};
  text-underline-offset: ${spacing.eighth};
`;

const compareByName = (a: string, b: string) => a.localeCompare(b);

const projectNameWithAdminRole = (project: Project) => `${project.name}: Org Admin`;

export const ProjectMembershipCell = ({ row }: { row: MemberRow }) => {
  const { projectsById, rolesById, projects } = useOrganizationMembersQueryContext();

  let projectCount = 0;
  let projectNames: string[] = [];

  if (row.orgAdmin) {
    // Org Admins have access to all projects
    projectCount = projects.length;
    projectNames =
      projectCount > 20
        ? [
            ...[...projects.map(projectNameWithAdminRole)].sort(compareByName).slice(0, 20),
            `...(${projectCount - 20}) more`,
          ]
        : projects.map(projectNameWithAdminRole);
  } else {
    projectCount = row.projectMemberships.length;
    projectNames = row.projectMemberships.map(
      (pm) => `${projectsById[pm.projectId]?.name}: ${rolesById[pm.roleId]?.name}`,
    );
  }

  return (
    <TableCell>
      {projectCount > 0 ? (
        <Tooltip
          tooltipContent={
            <UlNoPadding>
              {projectNames?.map((name, index) => (
                <li key={index}>{name}</li>
              ))}
            </UlNoPadding>
          }
        >
          <Body2Underline>{projectCount}</Body2Underline>
        </Tooltip>
      ) : (
        <Body2>0</Body2>
      )}
    </TableCell>
  );
};
